import { render, staticRenderFns } from "./ConsultoriaAnexoDownload.vue?vue&type=template&id=1d539990"
import script from "./ConsultoriaAnexoDownload.vue?vue&type=script&lang=js"
export * from "./ConsultoriaAnexoDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports